import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import { addMonths, addDays } from 'date-fns';
import classNames from 'classnames';
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl';
import thunkShape from 'helpers/thunk.shape';
import { ec } from 'helpers/multitrack';
import { EFFECTIVE_IMMEDIATELY, EFFECTIVE_NEXT_CYCLE } from 'constants/plan-change-effective-dates';
import { parseUnixSecondsDate } from 'helpers/time';
import { ERROR_NO_PAYMENT_SOURCE } from './PlanConfirmationModal.saga';
export var PlanConfirmationModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PlanConfirmationModal, _React$Component);

  function PlanConfirmationModal(props) {
    var _this;

    _classCallCheck(this, PlanConfirmationModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlanConfirmationModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleMaybeClick", function () {
      if (_this.props.immediateOnly || _this.props.allowImmediate && _this.state.selectedPlan === EFFECTIVE_IMMEDIATELY) {
        _this.handleSubmit(EFFECTIVE_IMMEDIATELY);

        return;
      }

      _this.handleSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectNextCycle", function () {
      _this.setState({
        selectedPlan: EFFECTIVE_NEXT_CYCLE
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectImmediate", function () {
      _this.setState({
        selectedPlan: EFFECTIVE_IMMEDIATELY
      });
    });

    _defineProperty(_assertThisInitialized(_this), "maybeRenderError", function () {
      var error = _this.props.error;
      var errorMessage;

      if (error) {
        if (typeof error === 'string') {
          errorMessage = error;
        } else if (error.code === ERROR_NO_PAYMENT_SOURCE) {
          errorMessage = React.createElement(FormattedMessage, {
            id: "planSelection.modal.errors.billingInfoMissing",
            defaultMessage: "Oops! We were unable to process your credit card."
          });
        } else {
          errorMessage = error.message;
        }
      }

      return errorMessage && React.createElement("div", {
        className: "error__text"
      }, errorMessage);
    });

    _this.state = {
      selectedPlan: EFFECTIVE_NEXT_CYCLE
    };
    return _this;
  }

  _createClass(PlanConfirmationModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          immediateOnly = _this$props.immediateOnly,
          allowImmediate = _this$props.allowImmediate,
          currentSubscription = _this$props.currentSubscription,
          plan = _this$props.plan,
          referralSource = _this$props.referralSource,
          prioritizeImmediate = _this$props.prioritizeImmediate;
      var effectiveDateOptions;

      if (immediateOnly) {
        effectiveDateOptions = [EFFECTIVE_IMMEDIATELY];
      } else if (allowImmediate) {
        effectiveDateOptions = [EFFECTIVE_IMMEDIATELY, EFFECTIVE_NEXT_CYCLE];
      } else {
        effectiveDateOptions = [EFFECTIVE_NEXT_CYCLE];
      }

      ec('Manage Membership - Select Plan', {
        page_type: 'plan_switching',
        action: 'confirm_plan',
        current_plan_code: currentSubscription.plan.plan_code,
        pending_plan_id: plan.id,
        pending_plan_code: plan.plan_code,
        effective_date_options: effectiveDateOptions,
        referral_source: referralSource || '',
        prioritize_immediate: !!prioritizeImmediate
      });
    }
  }, {
    key: "getNextCycleDate",
    value: function getNextCycleDate() {
      return parseUnixSecondsDate(this.props.currentSubscription.next_cycle);
    }
  }, {
    key: "getImmediateCycleStart",
    value: function getImmediateCycleStart() {
      return new Date();
    }
  }, {
    key: "getImmediateCycleEnd",
    value: function getImmediateCycleEnd() {
      var nextMonth = addMonths(new Date(), 1);
      return addDays(nextMonth, -1);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var effective = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EFFECTIVE_NEXT_CYCLE;
      var _this$props2 = this.props,
          plan = _this$props2.plan,
          prioritizeImmediate = _this$props2.prioritizeImmediate,
          referralSource = _this$props2.referralSource,
          switchSubscription = _this$props2.switchSubscription;

      if (this.isLoading()) {
        return;
      }

      switchSubscription({
        newPlanId: plan.id,
        effective: effective,
        trackingData: {
          prioritize_immediate: !!prioritizeImmediate,
          referral_source: referralSource || ''
        }
      });
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      var _this$props3 = this.props,
          subscription = _this$props3.subscription,
          leaving = _this$props3.leaving;
      return subscription.loading || leaving;
    }
  }, {
    key: "maybeRenderImmediateDetails",
    value: function maybeRenderImmediateDetails() {
      var _this$props4 = this.props,
          plan = _this$props4.plan,
          hasTax = _this$props4.hasTax;

      if (this.state.selectedPlan !== EFFECTIVE_IMMEDIATELY) {
        return;
      }

      var price = this.renderPrice();
      var tax = this.renderTax();
      var upgradePrice = this.renderPrice(plan.immediate_upgrade_price);
      var values = {
        price: price,
        date: React.createElement(FormattedDate, {
          timeZone: "utc",
          value: this.getNextCycleDate(),
          day: "numeric",
          month: "short"
        }),
        count: plan.org_visits_per_cycle,
        tax: hasTax ? tax : '',
        upgradePrice: upgradePrice,
        upgradedRemaining: plan.upgraded_remaining_balance,
        upgradedTotal: plan.upgraded_plan_total
      };
      return React.createElement("div", {
        className: "plan-selection__immediate__details text--left text--xs -mt-- mb"
      }, React.createElement(FormattedMessage, {
        id: "planSelection.modal.selection.immediate.credits.details",
        defaultMessage: "Today, you will be charged {upgradePrice}{tax} \u2013 the difference between your current plan and your new plan. You have {upgradedRemaining} of {upgradedTotal} credits to use this month, and up to 10 credits will roll over automatically to your next month. Beginning on {date}, you will be charged {price}/mo{tax}.",
        values: values
      }));
    }
  }, {
    key: "maybeRenderNextCycleModalBody",
    value: function maybeRenderNextCycleModalBody() {
      if (!this.props.allowImmediate) {
        return React.createElement("div", {
          className: "mv"
        }, this.renderEffectiveDate());
      }
    }
  }, {
    key: "maybeRenderAllowImmediateModalBody",
    value: function maybeRenderAllowImmediateModalBody() {
      if (this.props.allowImmediate) {
        return React.createElement("div", {
          className: "plan-selection__allow-immediate pl"
        }, React.createElement("div", {
          className: "plan-selection__options mt+ mb"
        }, React.createElement("div", {
          onClick: this.handleSelectNextCycle
        }, React.createElement("label", {
          className: "mb+",
          htmlFor: "selection-next-cycle"
        }, React.createElement("input", {
          type: "radio",
          name: "select-next-cycle",
          value: EFFECTIVE_NEXT_CYCLE,
          checked: this.state.selectedPlan === EFFECTIVE_NEXT_CYCLE
        }), React.createElement("div", {
          className: "plan-selection__details ml-"
        }, React.createElement("strong", {
          className: "mb--"
        }, React.createElement(FormattedMessage, {
          id: "planSelection.modal.selection.option.next-cycle",
          defaultMessage: "Switch next cycle"
        })), this.renderEffectiveDate()))), React.createElement("div", {
          onClick: this.handleSelectImmediate
        }, React.createElement("label", {
          htmlFor: "select-immediate"
        }, React.createElement("input", {
          type: "radio",
          name: "select-immediate",
          value: EFFECTIVE_IMMEDIATELY,
          checked: this.state.selectedPlan === EFFECTIVE_IMMEDIATELY
        }), React.createElement("div", {
          className: "plan-selection__details ml-"
        }, React.createElement("strong", {
          className: "mb--"
        }, React.createElement(FormattedMessage, {
          id: "planSelection.modal.selection.option.immediate",
          defaultMessage: "Switch immediately"
        })), React.createElement(FormattedMessage, {
          id: "planSelection.modal.selection.immediate",
          defaultMessage: "This will take effect today"
        }))))), this.maybeRenderImmediateDetails());
      }
    }
  }, {
    key: "maybeRenderConfirmationModal",
    value: function maybeRenderConfirmationModal() {
      var _this$props5 = this.props,
          prioritizeImmediate = _this$props5.prioritizeImmediate,
          allowImmediate = _this$props5.allowImmediate;

      if (prioritizeImmediate && allowImmediate) {
        return;
      }

      return React.createElement("div", {
        className: "plan-selection__body"
      }, this.maybeRenderNextCycleModalBody(), this.maybeRenderAllowImmediateModalBody(), React.createElement("button", {
        disabled: this.isLoading(),
        onClick: this.handleMaybeClick,
        className: classNames('bt bt--primary bt--lg', {
          'bt--waiting': this.isLoading()
        })
      }, this.renderConfirmationButtonText()), React.createElement("div", {
        className: "plan-selection__terms bg--light text--light text--sm mt+ p+ ph++"
      }, this.renderTerms()));
    }
  }, {
    key: "maybeRenderPrioritizeImmediateModal",
    value: function maybeRenderPrioritizeImmediateModal() {
      var _this$props6 = this.props,
          prioritizeImmediate = _this$props6.prioritizeImmediate,
          allowImmediate = _this$props6.allowImmediate;

      if (prioritizeImmediate && allowImmediate) {
        return React.createElement("div", null, React.createElement("button", {
          disabled: this.isLoading(),
          onClick: this.handleSubmit.bind(this, EFFECTIVE_IMMEDIATELY),
          className: classNames('bt bt--primary bt--lg mt', {
            'bt--waiting': this.isLoading()
          })
        }, React.createElement(FormattedMessage, {
          id: "planSelection.modal.confirm-immediate",
          defaultMessage: "Confirm plan change"
        })), React.createElement("div", {
          className: "text--light text--sm mv"
        }, React.createElement(FormattedMessage, {
          id: "planSelection.modal.prioritizeImmediateTerm1",
          defaultMessage: "You will be charged today and reset your cycle to start today. Any unused classes on your old plan will not rollover."
        })), React.createElement("div", {
          className: "mt"
        }, React.createElement(FormattedMessage, {
          id: "planSelection.modal.waitMessage",
          defaultMessage: "Wait until your next cycle ({cycleDate})",
          values: {
            cycleDate: React.createElement(FormattedDate, {
              timeZone: "utc",
              value: this.getNextCycleDate(),
              day: "numeric",
              month: "long"
            })
          }
        }), React.createElement("p", {
          className: "mt"
        }, React.createElement("a", {
          className: classNames({
            'plan-selection__immediate-cta--loading': this.isLoading()
          }),
          onClick: this.handleSubmit.bind(this, EFFECTIVE_NEXT_CYCLE)
        }, React.createElement("strong", null, React.createElement(FormattedMessage, {
          id: "planSelection.modal.next-cycle.cta",
          defaultMessage: "Confirm for your next cycle"
        }))))), React.createElement("div", {
          className: "text--light text--sm mt mb0"
        }, React.createElement(FormattedMessage, {
          id: "planSelection.modal.prioritizeImmediateTerm2",
          defaultMessage: "Beginning on the next cycle start date, you will automatically be charged each month for your new plan."
        })));
      }
    }
  }, {
    key: "maybeRenderCreditPlanName",
    value: function maybeRenderCreditPlanName() {
      var _this$props7 = this.props,
          showComembershipDetails = _this$props7.showComembershipDetails,
          plan = _this$props7.plan;

      if (showComembershipDetails) {
        return;
      }

      return React.createElement(FormattedMessage, {
        id: "planSelection.modal.credits.plan-name",
        defaultMessage: "{count}-credit plan",
        values: {
          count: plan.credits_per_cycle
        }
      });
    }
  }, {
    key: "renderTermsLink",
    value: function renderTermsLink() {
      return React.createElement("a", {
        href: "/terms",
        target: "_blank",
        rel: "noopener noreferrer"
      }, React.createElement(FormattedMessage, {
        id: "planSelection.modal.terms",
        defaultMessage: "Terms of Use"
      }));
    }
  }, {
    key: "renderPrice",
    value: function renderPrice() {
      var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.plan.price;
      var plan = this.props.plan;
      return React.createElement(FormattedNumber, {
        value: price,
        style: "currency",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currency: plan.currency_code
      });
    }
  }, {
    key: "renderTax",
    value: function renderTax() {
      return React.createElement("span", {
        className: "ml--"
      }, React.createElement(FormattedMessage, {
        id: "planSelection.modal.plusTax",
        defaultMessage: "+tax"
      }));
    }
  }, {
    key: "renderPrivacyLink",
    value: function renderPrivacyLink() {
      return React.createElement("a", {
        href: "/privacy",
        target: "_blank",
        rel: "noopener noreferrer"
      }, React.createElement(FormattedMessage, {
        id: "planSelection.modal.privacy",
        defaultMessage: "Privacy Policy"
      }));
    }
  }, {
    key: "renderTerms",
    value: function renderTerms() {
      var _this$props8 = this.props,
          showComembershipDetails = _this$props8.showComembershipDetails,
          comembershipDetails = _this$props8.comembershipDetails,
          immediateOnly = _this$props8.immediateOnly,
          hasTax = _this$props8.hasTax;

      var _ref = comembershipDetails || {},
          termsLink = _ref.termsLink,
          termsTitle = _ref.termsTitle;

      var price = this.renderPrice();
      var tax = this.renderTax();
      var terms = this.renderTermsLink();
      var privacy = this.renderPrivacyLink();

      if (showComembershipDetails) {
        return React.createElement(FormattedMessage, {
          id: "planSelection.modal.comembership.terms",
          defaultMessage: "By switching plans you agree that beginning on the date indicated above, you will automatically be charged each month for your new plan until you cancel, which you can do on the site at any time.  By confirming your plan change, you agree to the ClassPass {terms}, the ClassPass {privacy}, the {comembership}.",
          values: {
            terms: terms,
            privacy: privacy,
            comembership: React.createElement("a", {
              href: termsLink,
              target: "_blank",
              rel: "noopener noreferrer"
            }, termsTitle)
          }
        });
      }

      if (immediateOnly) {
        return React.createElement(FormattedMessage, {
          className: "terms-text",
          id: "planSelection.modal.terms.by-signing",
          defaultMessage: "By signing up you agree to be charged {price}{tax} starting today, {today}, and renewed each month until you cancel, which you can do any time. You agree to the {terms} and {privacy}.",
          values: {
            price: price,
            terms: terms,
            privacy: privacy,
            today: React.createElement(FormattedDate, {
              timeZone: "utc",
              value: this.getImmediateCycleStart(),
              day: "numeric",
              month: "short"
            }),
            tax: hasTax ? tax : ''
          }
        });
      }

      return React.createElement(FormattedMessage, {
        id: "planSelection.modal.terms.by-switching",
        defaultMessage: "By switching plans you agree that beginning on the date indicated above, you will automatically be charged each month for your new plan until you cancel, which you can do on the site at any time.  You agree to the {terms} and {privacy}.",
        values: {
          terms: terms,
          privacy: privacy
        }
      });
    }
  }, {
    key: "renderEffectiveDate",
    value: function renderEffectiveDate() {
      if (this.props.immediateOnly) {
        return React.createElement(FormattedMessage, {
          id: "planSelection.modal.date.immediately",
          defaultMessage: "This will take effect immediately"
        });
      }

      return React.createElement(FormattedMessage, {
        id: "planSelection.modal.date",
        defaultMessage: "This will take effect on {date}",
        values: {
          date: React.createElement(FormattedDate, {
            timeZone: "utc",
            value: this.getNextCycleDate(),
            day: "numeric",
            month: "long"
          })
        }
      });
    }
  }, {
    key: "renderConfirmationButtonText",
    value: function renderConfirmationButtonText() {
      if (this.props.immediateOnly) {
        return React.createElement(FormattedMessage, {
          id: "planSelection.modal.confirmAndStartNow",
          defaultMessage: "Confirm plan and start now"
        });
      }

      return React.createElement(FormattedMessage, {
        id: "planSelection.modal.confirm",
        defaultMessage: "Confirm plan change"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          showComembershipDetails = _this$props9.showComembershipDetails,
          prioritizeImmediate = _this$props9.prioritizeImmediate,
          plan = _this$props9.plan,
          hasTax = _this$props9.hasTax;
      return React.createElement("div", {
        className: classNames('modal__body', {
          'modal__plan-confirmation--prioritize-immediate': prioritizeImmediate,
          'modal__plan-confirmation--immediate': !prioritizeImmediate
        })
      }, React.createElement("div", {
        className: "modal__column"
      }, React.createElement("div", null, this.maybeRenderError(), React.createElement("div", {
        className: "modal__confirmation-message"
      }, React.createElement(FormattedMessage, {
        id: "planSelection.modal.review",
        defaultMessage: "Review your selection"
      })), React.createElement("h3", {
        className: "mv"
      }, this.maybeRenderCreditPlanName(), showComembershipDetails && plan.sell_name), React.createElement(FormattedMessage, {
        id: "planSelection.modal.price",
        defaultMessage: "{price} per month",
        values: {
          price: this.renderPrice()
        }
      }), React.createElement("span", {
        className: "text--regular"
      }, hasTax && this.renderTax()), React.createElement("br", null), this.maybeRenderConfirmationModal(), this.maybeRenderPrioritizeImmediateModal())));
    }
  }]);

  return PlanConfirmationModal;
}(React.Component);
PlanConfirmationModal.propTypes = {
  allowImmediate: PropTypes.bool,
  comembershipDetails: PropTypes.shape({
    termsLink: PropTypes.string,
    termsTitle: PropTypes.string
  }),
  currentSubscription: PropTypes.object.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    code: PropTypes.number,
    message: PropTypes.string
  })]),
  hasTax: PropTypes.bool,
  immediateOnly: PropTypes.bool.isRequired,
  leaving: PropTypes.bool,
  plan: PropTypes.object.isRequired,
  prioritizeImmediate: PropTypes.bool,
  referralSource: PropTypes.string,
  showComembershipDetails: PropTypes.bool,
  subscription: thunkShape(),
  switchSubscription: PropTypes.func.isRequired
};